import { render, staticRenderFns } from "./UploadAGMModal.vue?vue&type=template&id=45b982f0"
import script from "./UploadAGMModal.vue?vue&type=script&lang=js"
export * from "./UploadAGMModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports